export default "__VITE_ASSET__bff866b8__"